interface ContainerProps {
  children: React.ReactNode;
}

const Container = (props: ContainerProps) => {
  return <div style={styles.container}>{props.children}</div>;
};

const styles = {
  container: {
    justifyContent: "center",
    paddingLeft: "100px",
    paddingRight: "100px",
  },
};

export default Container;
